import { useTheme } from "styled-components";
import { IModalProps } from "../../@interfaces";
import CloseButton from "../closebutton";
import { Content, Header, ModalContainer, Overlay } from "./style";



const BaseModal: React.FC<IModalProps> = ({ closeModal, children, width }) => {
  const theme = useTheme();
  
  return (
    <Overlay>
      <ModalContainer width={width}>
        <Header>
          <CloseButton handleClose={closeModal} color={theme.colors.black} />
        </Header>
        <Content>
          {children}
        </Content>
      </ModalContainer>
    </Overlay>
  )
}

export default BaseModal;